import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import { Providers } from "app/utils/constants/data";
import { addslashes } from "app/utils/utils";
import cloneDeep from "lodash.clonedeep";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  accountsList: [],
  externalProvidersList: [],
  paymentHistory: [],
  totalPayments: 0,
  accountDetails: {
    name: "",
    company_id: "",
    tag_id: "",
    email: "",
    phone: "",
    address: "",
    margin: "",
    bc_email: "",
    cs_email: "",
    po_email: "",
    logoUrl: "",
    theme: "",
    id: "",
    has_direct_publishers: "0",
    is_prepaid: "0",
    total_received: 0,
    total_spent: 0,
    balance: 0,
    show_global_providers: 0,
    audience_providers: "",
    audience_targeting: 0,
    conv_1_label: "",
    conv_2_label: "",
    conv_3_label: "",
    conv_4_label: "",
    bidder_endpoints_limit: "",
    seller_account_id: "",
    rev_share: "",
    hide_report_metrics: "",
  },
  history_table_loading: false,

  accountFilters: {
    organizations: [],
  },
  accountFilterFormValues: {
    organizations: [],
  },
};

export const GetAllAccountsListThunk = createAsyncThunk(
  "company/GetAllAccountsListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var accountFilters = payload?.accountFilters;
    let condition = [];

    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "(name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%' or company " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%')"
      );
    }
    //console.log("accountFilters", accountFilters);
    if (accountFilters?.organizations.length > 0 && isSysAdmin == 1) {
      condition.push(
        "company_id IN ('" + accountFilters?.organizations.join("','") + "')"
      );
    }
    if (isSysAdmin != 1) {
      let authAdvAccounts = payload.user_data?.user_assoc_accounts?.advertiser
        ? payload.user_data?.user_assoc_accounts?.advertiser
        : [];
      let authPubAccounts = payload.user_data?.user_assoc_accounts?.publisher
        ? payload.user_data?.user_assoc_accounts?.publisher
        : [];

      if (authAdvAccounts.length > 0 || authPubAccounts.length > 0) {
        let authAccounts = [...authAdvAccounts, ...authPubAccounts];
        condition.push("id IN ('" + authAccounts.join("','") + "')");
      }
    }
    condition.push("active in ('0','1')");
    let where = "";
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }
    const queryBody = {
      queries: [
        {
          query:
            `select id,name,email,company,company_id,is_prepaid,active,(select name from ${DATASOURCE_CONFIG.TABLE_PREFIX}companies where id=company_id ) as company_name,(SELECT count(*) FROM advertisers WHERE accountid =accounts.id and active=1 ) as has_advertisers,(SELECT count(*) FROM publishers WHERE accountid =accounts.id and active=1 ) as has_publishers from ${DATASOURCE_CONFIG.TABLE_PREFIX}accounts ` +
            where +
            ` order by creation_date desc`,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetExternalProvidersListThunk = createAsyncThunk(
  "account/GetExternalProvidersListThunk",
  async (payload) => {
    //Providers
    const queryBody = {
      queries: [
        {
          query:
            `select code,name,email,address,is_external,cookie_sync_url,description from ${DATASOURCE_CONFIG.TABLE_PREFIX}audience_provider_details ` +
            ` where is_external=1 and active=1 and code in ('${Providers.join(
              "','"
            )}')`,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateAccountDetailsThunk = createAsyncThunk(
  "company/InsertUpdateAccountDetailsThunk",
  async (payload) => {
    //console.log('payload', payload)
    let insertUpdateQuery = "";

    if (payload.action == "add") {
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "accounts (id,name,company_id,tag_id,company,email,phone,address,margin,bc_email,cs_email,po_email,creation_date,updated,logo_url,theme,has_direct_publishers,created_by,is_prepaid,is_seat_on_platform,story_cost_value,pixel_domain,show_global_providers,audience_providers,audience_targeting,conv_1_label,conv_2_label,conv_3_label,conv_4_label,bidder_endpoints_limit,seller_account_id,rev_share,hide_report_metrics) values('" +
        payload.id +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.company_id +
        "','" +
        payload.tag_id +
        "','" +
        addslashes(payload.company_name) +
        "','" +
        addslashes(payload.email) +
        "','" +
        payload.phone +
        "','" +
        addslashes(payload.address) +
        "','" +
        payload.margin +
        "','" +
        addslashes(payload.bc_email) +
        "','" +
        addslashes(payload.cs_email) +
        "','" +
        addslashes(payload.po_email) +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",'" +
        payload.logoUrl +
        "','" +
        payload.theme +
        "','" +
        payload.has_direct_publisher +
        "','" +
        payload.created_by +
        "','" +
        payload.is_prepaid +
        "','" +
        payload.is_seat_on_platform +
        "','" +
        payload.story_cost +
        "','" +
        payload.pixel_domain +
        "','" +
        payload.show_global_providers +
        "','" +
        payload.audience_providers +
        "','" +
        payload.audience_targeting +
        "','" +
        addslashes(payload.conv_1_label) +
        "','" +
        addslashes(payload.conv_2_label) +
        "','" +
        addslashes(payload.conv_3_label) +
        "','" +
        addslashes(payload.conv_4_label) +
        "','" +
        payload.bidder_endpoints_limit +
        "','" +
        payload.seller_account_id +
        "','" +
        payload.rev_share +
        "','" +
        addslashes(payload.hide_report_metrics) +
        "') ";
    } else {
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "accounts set name='" +
        addslashes(payload.name) +
        "',company_id='" +
        payload.company_id +
        "',tag_id='" +
        payload.tag_id +
        "',company='" +
        addslashes(payload.company_name) +
        "',email='" +
        addslashes(payload.email) +
        "',phone='" +
        payload.phone +
        "',address='" +
        addslashes(payload.address) +
        "',margin='" +
        payload.margin +
        "',bc_email='" +
        addslashes(payload.bc_email) +
        "',cs_email='" +
        addslashes(payload.cs_email) +
        "',po_email='" +
        addslashes(payload.po_email) +
        "',logo_url='" +
        payload.logoUrl +
        "',theme='" +
        payload.theme +
        "',has_direct_publishers='" +
        payload.has_direct_publisher +
        "',updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",is_seat_on_platform='" +
        payload.is_seat_on_platform +
        "',story_cost_value='" +
        payload.story_cost +
        "',pixel_domain='" +
        payload.pixel_domain +
        "',show_global_providers='" +
        payload.show_global_providers +
        "',audience_providers='" +
        payload.audience_providers +
        "',audience_targeting='" +
        payload.audience_targeting +
        "',conv_1_label='" +
        addslashes(payload.conv_1_label) +
        "',conv_2_label='" +
        addslashes(payload.conv_2_label) +
        "',conv_3_label='" +
        addslashes(payload.conv_3_label) +
        "',conv_4_label='" +
        addslashes(payload.conv_4_label) +
        "',bidder_endpoints_limit='" +
        payload.bidder_endpoints_limit +
        "',seller_account_id='" +
        payload.seller_account_id +
        "',rev_share='" +
        payload.rev_share +
        "',hide_report_metrics='" +
        addslashes(payload.hide_report_metrics) +
        "' where id='" +
        payload.id +
        "'";
    }
    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "accounts",
            columns:
              "id,name,company_id,tag_id,company,email,phone,address,margin,bc_email,cs_email,po_email,logo_url,theme,has_direct_publishers,created_by,is_prepaid",
            id: payload.id,
            user_details: payload.user_details,
            context: "accounts",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
/*
 * Quote a value for the single-quoted literals these statements are built from.
 *
 * A remark is free text an operator types, and the one typed for an adjustment
 * reads like "Due to client's incorrect setup" -- an apostrophe closes the
 * literal early and the insert fails, losing the adjustment and saying only
 * that something went wrong.
 *
 * Backslash first, or the escape this adds is itself escaped. Same spelling as
 * `escapeSqlLiteral` in AudienceSegments and `sqlEscape` in AudiencePanel,
 * which is MySQL's, and MySQL is what DATASOURCE_CONFIG selects.
 *
 * This is a correctness fix and not a security one. These statements are built
 * in the browser and posted to an endpoint that runs whatever it is sent, so
 * quoting a field here closes nothing that is not already open.
 */
const escapeSqlLiteral = (value) =>
  String(value == null ? "" : value)
    .replace(/\\/g, "\\\\")
    .replace(/'/g, "\\'");

export const createAccountFinance = createAsyncThunk(
  "company/createAccountFinance",
  async (payload) => {
    //console.log('payload', payload)
    let insertUpdateQuery = "";

    insertUpdateQuery =
      "insert into " +
      tablePrefix +
      "accounts_finance (id,payment,userid,accountid,ipaddress,creation_date,remarks,mode_of_payment) values('" +
      escapeSqlLiteral(uuid()) +
      "','" +
      escapeSqlLiteral(payload.amount) +
      "','" +
      escapeSqlLiteral(payload.user_id) +
      "','" +
      escapeSqlLiteral(payload.account_id) +
      "','" +
      escapeSqlLiteral(payload.ip_address) +
      "',now(),'" +
      escapeSqlLiteral(payload.remarks) +
      "','" +
      escapeSqlLiteral(payload.mode_of_payment) +
      "') ";

    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAccountDetailsThunk = createAsyncThunk(
  "company/GetAccountDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,company_id,tag_id,company,email,phone,address,margin,bc_email,cs_email,po_email,logo_url,theme,has_direct_publishers,active,is_prepaid,is_seat_on_platform,story_cost_value,pixel_domain,show_global_providers,audience_providers,audience_targeting,conv_1_label,conv_2_label,conv_3_label,conv_4_label,bidder_endpoints_limit,seller_account_id,rev_share, (select sum(payment) as received from accounts_finance where accountid=accounts.id) as total_received,prepaid_gross as total_spent,hide_report_metrics from " +
            tablePrefix +
            "accounts where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAccountFinanceDataForTable = createAsyncThunk(
  "company/GetAccountFinanceDataForTable",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,payment,userid,accountid,ipaddress,DATE_FORMAT(creation_date,'%Y-%m-%d %H:%i:%s') as creation_date,remarks,mode_of_payment,(select name from users where id=accounts_finance.userid) as user_name,(select name from accounts where id=accounts_finance.accountid) as account_name from " +
            tablePrefix +
            "accounts_finance where accountid ='" +
            payload.accountId +
            "' and creation_date >='" +
            payload.start_date +
            "' and creation_date <='" +
            payload.end_date +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select sum(payment) as total_payments from " +
            tablePrefix +
            "accounts_finance where accountid ='" +
            payload.accountId +
            "' and creation_date >='" +
            payload.start_date +
            "' and creation_date <='" +
            payload.end_date +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateAccountStatusThunk = createAsyncThunk(
  "account/UpdateAccountStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "accounts set active='" +
            payload.status +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "accounts",
            columns: "active",
            id: payload.id,
            user_details: payload.user_details,
            context: "accounts",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Account = createSlice({
  name: "account",
  initialState,
  reducers: {
    resetAccountForm(state, action) {
      state.accountDetails = {
        name: "",
        company_id: "",
        tag_id: "",
        company: "",
        email: "",
        phone: "",
        address: "",
        margin: "",
        bc_email: "",
        cs_email: "",
        po_email: "",
        logoUrl: "",
        theme: "",
        has_direct_publishers: "0",
        is_prepaid: "0",
        total_received: 0,
        total_spent: 0,
        balance: 0,
        is_seat_on_platform: 0,
        show_global_providers: 0,
        audience_providers: "",
        audience_targeting: 0,
        conv_1_label: "",
        conv_2_label: "",
        conv_3_label: "",
        conv_4_label: "",
        bidder_endpoints_limit: "",
        seller_account_id: "",
        rev_share: "",
        hide_report_metrics: "",
      };
    },
    resetPrepaidAccountDetails(state, action) {
      state.paymentHistory = [];
      state.totalPayments = 0;
    },
    updateAccountFiltersFormValues(state, action) {
      let accountFilters = cloneDeep(state.accountFilterFormValues);
      if (action.payload?.action == "delete") {
        accountFilters = {
          organizations: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        accountFilters[type] = data;
      }

      state.accountFilterFormValues = accountFilters;
    },
    updateAccountFilters(state, action) {
      let accountFilters = cloneDeep(state.accountFilters);
      accountFilters.organizations = action.payload.organizations;
      state.accountFilters = accountFilters;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllAccountsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllAccountsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0]) {
          state.accountsList = action.payload.data.results[0];
        }
        // if (action.payload.data.status === 1) {
        // } else if (action.payload.data.status == 0) {
        //     // toast.error(action.payload.data.message);
        // }
        // if (state.globalAccountsList.length > 0) {
        //     state.globalAccount = state.globalAccountsList[0].value;
        //     console.log("state.globalAccount", state.globalAccount);
        // }
        state.loading = false;
      })
      .addCase(GetAllAccountsListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateAccountDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdateAccountDetailsThunk.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
          let accountData = { ...state.accountDetails };

          accountData.name = action.meta.arg.name;
          accountData.company_id = action.meta.arg.company_id;
          accountData.tag_id = action.meta.arg.tag_id;
          accountData.company = action.meta.arg.company_name;
          accountData.email = action.meta.arg.email;
          accountData.phone = action.meta.arg.phone;
          accountData.address = action.meta.arg.address;
          accountData.margin = action.meta.arg.margin;
          accountData.bc_email = action.meta.arg.bc_email;
          accountData.cs_email = action.meta.arg.cs_email;
          accountData.po_email = action.meta.arg.po_email;
          accountData.logoUrl = action.meta.arg.logoUrl;
          accountData.theme = action.meta.arg.theme;
          accountData.has_direct_publishers =
            action.meta.arg.has_direct_publisher;
          accountData.is_prepaid = action.meta.arg.is_prepaid;
          accountData.is_seat_on_platform = action.meta.arg.is_seat_on_platform;
          accountData.story_cost = action.meta.arg.story_cost;
          accountData.pixel_domain = action.meta.arg.pixel_domain;
          accountData.show_global_providers =
            action.meta.arg.show_global_providers;
          accountData.audience_providers = action.meta.arg.audience_providers;
          accountData.audience_targeting = action.meta.arg.audience_targeting;
          accountData.conv_1_label = action.meta.arg.conv_1_label;
          accountData.conv_2_label = action.meta.arg.conv_2_label;
          accountData.conv_3_label = action.meta.arg.conv_3_label;
          accountData.conv_4_label = action.meta.arg.conv_4_label;
          accountData.bidder_endpoints_limit =
            action.meta.arg.bidder_endpoints_limit;
          accountData.seller_account_id = action.meta.arg.seller_account_id;
          accountData.rev_share = action.meta.arg.rev_share;
          accountData.hide_report_metrics = action.meta.arg.hide_report_metrics;

          state.accountDetails = accountData;
          //state.accountsDetails = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(InsertUpdateAccountDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetAccountDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAccountDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let resultData = action.payload.data?.results[0][0];

          let accountData = {
            name: resultData.name,
            company_id: resultData.company_id,
            tag_id: resultData.tag_id,
            company: resultData.company,
            email: resultData.email,
            phone: resultData.phone,
            address: resultData.address,
            margin: resultData.margin,
            bc_email: resultData.bc_email,
            cs_email: resultData.cs_email,
            po_email: resultData.po_email,
            logoUrl: resultData.logo_url,
            theme: resultData.theme,
            has_direct_publishers: resultData.has_direct_publishers,
            is_prepaid: resultData.is_prepaid,
            total_received: resultData?.total_received,
            total_spent: resultData?.total_spent,
            balance:
              parseFloat(resultData?.total_received) -
              parseFloat(resultData?.total_spent),
            is_seat_on_platform: resultData.is_seat_on_platform,
            story_cost: resultData.story_cost_value,
            pixel_domain: resultData.pixel_domain,
            show_global_providers: resultData.show_global_providers,
            audience_providers: resultData.audience_providers,
            audience_targeting: resultData.audience_targeting,
            conv_1_label: resultData.conv_1_label,
            conv_2_label: resultData.conv_2_label,
            conv_3_label: resultData.conv_3_label,
            conv_4_label: resultData.conv_4_label,
            bidder_endpoints_limit: resultData.bidder_endpoints_limit,
            seller_account_id: resultData.seller_account_id,
            rev_share: resultData.rev_share,
            hide_report_metrics: resultData.hide_report_metrics,
          };
          state.accountDetails = accountData;
        }
        state.loading = false;
      })
      .addCase(GetAccountDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateAccountStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateAccountStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let accountList = state.accountsList;
          let accountId = action.meta.arg.id;
          let status = action.meta.arg.status;
          accountList.map((acinfo) => {
            if (acinfo.id == accountId) {
              acinfo.active = status;
            }
            return acinfo;
          });
          //accountList = accountList.filter((item) => item.id !== accountId);
          state.accountsList = accountList;
        }
        state.loading = false;
      })
      .addCase(UpdateAccountStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createAccountFinance.pending, (state) => {
        //state.loading = true;
      })
      .addCase(createAccountFinance.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          state.accountDetails.total_received =
            parseFloat(state.accountDetails.total_received) +
            parseFloat(action.meta.arg.amount);
          state.accountDetails.balance =
            parseFloat(state.accountDetails.balance) +
            parseFloat(action.meta.arg.amount);
        }
        // state.loading = false;
      })
      .addCase(createAccountFinance.rejected, (state, action) => {
        //state.loading = false;
      })
      .addCase(GetAccountFinanceDataForTable.pending, (state) => {
        state.history_table_loading = true;
      })
      .addCase(GetAccountFinanceDataForTable.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let resultData = action.payload.data?.results[0];
          let total_amount = action.payload.data?.results[1][0];

          state.paymentHistory = resultData;
          state.totalPayments = total_amount?.total_payments
            ? total_amount.total_payments
            : 0;
        }
        state.history_table_loading = false;
      })
      .addCase(GetAccountFinanceDataForTable.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.history_table_loading = false;
      })
      .addCase(GetExternalProvidersListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetExternalProvidersListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let dbProviders = action.payload.data.results[0];
          if (dbProviders.length > 0) {
            for (let k = 0; k < dbProviders.length; k++) {
              if (dbProviders[k]["code"] === "mobqcustom") {
                dbProviders[k]["name"] = "Audience Pixel Segments";
              }
            }
          }
          state.externalProvidersList = dbProviders;
        }
        state.loading = false;
      })
      .addCase(GetExternalProvidersListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      });

    //
  },
});
const { actions, reducer } = Account;
// Extract and export each action creator by name
export const {
  resetAccountForm,
  resetPrepaidAccountDetails,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
  updateAccountFiltersFormValues,
  updateAccountFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
